export default __webpack_public_path__ + "static/media/upload.8a7642cc.svg";